<div class="footer-bar"></div>
<footer class="footer container--nav">
    <div class="footer__top">
        <!--        <core-brand-logo category="FOOTER" additionalClasses="brand-logo&#45;&#45;footer"></core-brand-logo>-->

        @if (pages$ | async; as _pages) {
            <ul class="footer-links-list">
                @for (page of $any(_pages | orderBy: ['displayOrder']); track page) {
                    @if (
                        (page.meta.showFooterBar === "'true'" ||
                            page.meta.showFooterBar === true ||
                            page.meta.showFooterBar === 'true') &&
                        !['Login', 'Logout', 'Log in', 'Log out'].includes(page.name)
                    ) {
                        <li class="footer-links-list__item">
                            @if (page.meta.redirect && page.meta.redirect.startsWith('https://')) {
                                <a
                                    [core-analytics]="{ action: page.url, category: 'FOOTER' }"
                                    [href]="page.meta.redirect"
                                    [innerText]="page.name"
                                    class="footer-links-list__link"
                                    target="_blank"></a>
                            } @else {
                                <a
                                    [core-analytics]="{ action: page.url, category: 'FOOTER' }"
                                    [innerText]="page.name"
                                    [routerLink]="page.url === 'default' ? '/' : page.meta.redirect || '/' + page.url"
                                    class="footer-links-list__link"></a>
                            }
                        </li>
                    }
                }
            </ul>
        }
    </div>

    <div class="footer__bottom">
        <p class="footer__copyright">&copy; Gallagher {{ year }} |&nbsp;All Rights Reserved</p>

        @if (pages$ | async; as _pages) {
            <ul class="footer-links-list footer-links-list--bottom">
                @for (infoPage of $any(_pages | orderBy: ['displayOrder']); track infoPage) {
                    @if (
                        infoPage.meta.showFooterBarBottom === "'true'" ||
                        infoPage.meta.showFooterBarBottom === true ||
                        infoPage.meta.showFooterBarBottom === 'true'
                    ) {
                        <li class="footer-links-list__item">
                            @if (
                                infoPage.meta.redirect &&
                                (infoPage.meta.redirect.startsWith('http://') ||
                                    infoPage.meta.redirect.startsWith('https://'))
                            ) {
                                <a
                                    [core-analytics]="{ action: infoPage.url, category: 'FOOTER' }"
                                    [href]="infoPage.meta.redirect"
                                    [innerText]="infoPage.name"
                                    class="footer-links-list__link"
                                    target="_blank">
                                </a>
                            } @else {
                                <a
                                    [core-analytics]="{ action: infoPage.url, category: 'FOOTER' }"
                                    [innerText]="infoPage.name"
                                    [routerLink]="
                                        infoPage.url === 'default' ? '/' : infoPage.meta.redirect || '/' + infoPage.url
                                    "
                                    class="footer-links-list__link">
                                </a>
                            }
                        </li>
                    }
                }
                @if (cookiePolicy) {
                    <li class="footer-links-list__item">
                        <a
                            [core-analytics]="{ action: 'Cookie policy', category: 'FOOTER' }"
                            class="footer-links-list__link"
                            [href]="'//policy.cookiereports.com/' + cookiePolicy + '-en-gb.html'"
                            >Cookie Policy</a
                        >
                    </li>
                }
                <li class="footer-links-list__item">
                    <a
                        [core-analytics]="{ action: 'Privacy policy', category: 'FOOTER' }"
                        class="footer-links-list__link"
                        href="https://www.ajg.com/uk/global-privacy-notice"
                        target="_blank"
                        >Privacy Policy</a
                    >
                </li>
            </ul>
        }
    </div>
</footer>
